import React from 'react'
import styled from 'styled-components'

const COLORS = {
  success: '#48bb78',
  warning: '#f6e05e',
  error: '#f56565',
  default: '#cbd5e0',
}

const PROGRESS = {
  success: ['success', 'success', 'success'],
  warning: ['warning', 'warning', 'default'],
  error: ['error', 'default', 'default'],
  default: ['default', 'default', 'default'],
}

const LocationProgressBar = ({ progress = 0 }) => {
  let arr = null
  switch (true) {
    case progress >= 80:
      arr = PROGRESS.success
      break
    case progress >= 50:
      arr = PROGRESS.warning
      break
    case progress < 50:
      arr = PROGRESS.error
      break
    default:
      arr = PROGRESS.default
      break
  }
  return (
    <ProgressBarContainer>
      <ProgressBarCells>
        {arr.map((type, index) => (
          <ProgressBarCell key={index} type={type} />
        ))}
      </ProgressBarCells>

      <span>{progress}%</span>
    </ProgressBarContainer>
  )
}

const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  justify-content: flex-end;
  span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: var(--gray-800, #1a202c);
    font-feature-settings: 'liga' off, 'clig' off;
    text-overflow: ellipsis;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
`
const ProgressBarCells = styled.div`
  display: flex;
  max-width: 130px;
  align-items: flex-start;
  gap: 5px;
  flex: 1 0 0;
`

const ProgressBarCell = styled.div(
  ({ type = 'default' }) => `
  height: 6px;
  flex: 1 0 0;
  border-radius: 99px;
  background:  ${COLORS[type]};
`
)

export default LocationProgressBar
